import { jwtDecode } from "jwt-decode";

type AccessRightClaim = string | number | Array<string | number> | null | undefined;

function normalizeAccessRights(value: AccessRightClaim): string[] {
  if (Array.isArray(value)) {
    return value.map(String).map(function (item) {
      return item.trim();
    }).filter(Boolean);
  }

  if (value == null) {
    return [];
  }

  const text = String(value).trim();
  if (!text) {
    return [];
  }

  if (text.startsWith("[") && text.endsWith("]")) {
    try {
      return normalizeAccessRights(JSON.parse(text));
    } catch {
      // Fall back to the legacy comma-separated claim format.
    }
  }

  return text.split(",").map(function (item) {
    return item.trim();
  }).filter(Boolean);
}

export function getAccessRights(): string[] {
  const storedRights = normalizeAccessRights(localStorage.getItem("actionTypes"));
  if (storedRights.length > 0) {
    return storedRights;
  }

  const token = localStorage.getItem("jwt");
  if (!token) {
    return [];
  }

  try {
    const claims = jwtDecode<{ actiontype?: AccessRightClaim }>(token);
    const tokenRights = normalizeAccessRights(claims?.actiontype);
    if (tokenRights.length > 0) {
      localStorage.setItem("actionTypes", tokenRights.join(","));
    }
    return tokenRights;
  } catch {
    return [];
  }
}

export function hasAccessRight(id: string | number | null | undefined): boolean {
  if (id == null) {
    return false;
  }

  const expectedId = String(id).trim();
  if (!expectedId) {
    return false;
  }

  return getAccessRights().some(function (accessRight) {
    return accessRight === expectedId;
  });
}
